module.exports = __webpack_public_path__ + "img/20200430153427403.cb49343d.png";